import axios from "axios";
import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useLogout } from "./useLogout";
import { redirectToUnauthorized } from "../utils/auth/redirectToUnauthorized";

export function useAxiosAuthInterceptor() {
  const { isAuthenticated, isLoading } = useAuth();
  const logout = useLogout();

  useEffect(() => {
    const interceptor = axios.interceptors.response.use(
      (response) => response,
      (error) => {
        if (!isLoading && isAuthenticated) {
          if (error.response?.status === 401) {
            logout({ redirectPath: "/session-expired" });
          } else if (error.response?.status === 403) {
            redirectToUnauthorized();
          }
        }
        return Promise.reject(error);
      },
    );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, [isAuthenticated, isLoading, logout]);
}
